__turbopack_context__.v({
  "blocksBackgroundColor": "FollowFeedPageItem-module-scss-module__uI9Kia__blocksBackgroundColor",
  "blocksFontColor": "FollowFeedPageItem-module-scss-module__uI9Kia__blocksFontColor",
  "buttonContainer": "FollowFeedPageItem-module-scss-module__uI9Kia__buttonContainer",
  "externalLink": "FollowFeedPageItem-module-scss-module__uI9Kia__externalLink",
  "followButton": "FollowFeedPageItem-module-scss-module__uI9Kia__followButton",
  "hiddenWhenSmall": "FollowFeedPageItem-module-scss-module__uI9Kia__hiddenWhenSmall",
  "icon": "FollowFeedPageItem-module-scss-module__uI9Kia__icon",
  "orgContainer": "FollowFeedPageItem-module-scss-module__uI9Kia__orgContainer",
  "secondaryNavBackgroundColor": "FollowFeedPageItem-module-scss-module__uI9Kia__secondaryNavBackgroundColor",
  "section": "FollowFeedPageItem-module-scss-module__uI9Kia__section",
  "sectionInfo": "FollowFeedPageItem-module-scss-module__uI9Kia__sectionInfo",
  "sectionInfoNoContent": "FollowFeedPageItem-module-scss-module__uI9Kia__sectionInfoNoContent",
  "themeBackgroundColor": "FollowFeedPageItem-module-scss-module__uI9Kia__themeBackgroundColor",
  "themeFontColor": "FollowFeedPageItem-module-scss-module__uI9Kia__themeFontColor",
  "title": "FollowFeedPageItem-module-scss-module__uI9Kia__title",
  "type": "FollowFeedPageItem-module-scss-module__uI9Kia__type",
});
